// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';
import { UserLookupRow } from './userLookupRow.zod.ts';

export const UserLookupOut = zod.object({
  "users": zod.array(UserLookupRow)
});

export type UserLookupOut = zod.input<typeof UserLookupOut>;
export type UserLookupOutOutput = zod.output<typeof UserLookupOut>;
